import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NotifyService} from './services/notify.service';
import { MatSnackBarModule as MatSnackBarModule } from '@angular/material/snack-bar';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    MatSnackBarModule
  ],
  providers: [
    NotifyService,
  ]
})
export class BroverNotifyModule { }
